import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { profile } from "../../actions/auth";
import Agenda from "../agenda/Agenda";
import DashboardTitle from "./DashboardTitle";

/**
 * Dashboard : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Dashboard module which acts as a home screen
 * for logged-in users
 */
class Dashboard extends Component {
  /**
   * Fired on component mount, used to start fetching
   * required data
   */
  componentDidMount() {
    this.props.profile();
  }
  /**
   * Renders the dashboard
   */
  render() {
    return (
      <div>
        <DashboardTitle
          firstName={this.props.firstName}
          lastName={this.props.lastName}
          isLoading={!this.props.isProfileLoaded}
        />
        <Agenda />
      </div>
    );
  }
}

/**
 * mapStateToProps = state => props
 * Redux function that exposes name fields and isLoaded as props
 * to the component
 */
function mapStateToProps(state) {
  return {
    firstName: state.user.firstName,
    lastName: state.user.lastName,
    isProfileLoaded: !!state.user.firstName && !!state.user.lastName
  };
}

Dashboard.propTypes = {
  /**
   * profile: ()
   * Action to start fetching profile information
   */
  profile: PropTypes.func.isRequired,

  /**
   * firstName: String
   * First display name of the current user
   */
  firstName: PropTypes.string,

  /**
   * lastName: String
   * Last display name of the current user
   */
  lastName: PropTypes.string,

  /**
   * isProfileLoaded: Boolean
   * True if the profile has been loaded into Redux
   */
  isProfileLoaded: PropTypes.bool.isRequired
};

Dashboard.defaultProps = {
  firstName: "",
  lastName: ""
};

export default connect(
  mapStateToProps,
  { profile }
)(Dashboard);



// WEBPACK FOOTER //
// ./src/modules/dashboard/Dashboard.js